<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
    header: string,
    icon?: Component | string
}>();
</script>

<template>
    <div>
        <slot />
    </div>
</template>